import $ from "jquery";
import 'bootstrap'
import styles from './assets/scss/app.scss';
import scripts from './assets/js/app.js';

require('./assets/js/jquery-global');
require('./assets/js/jquery-template');
require('./assets/js/lwsreviews-feed');
require('./assets/js/vue/app');